module.exports = (__webpack_require__("dll-reference common"))("./template/css/index.css");